import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { OrderService } from '../../shared/services/order.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { OrderDetailsBus } from '../../shared/models/OrderDetailsBus';
import { CommonFunctions } from '../../shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { v_InventoryBus } from '@app/cp/shared/models/v_InventoryBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventorySuppliersBus } from '@app/cp/shared/models/InventorySuppliersBus';
import { OrderMessageInfo } from '@app/cp/shared/models/OrderMessageInfo';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { aggregateBy } from '@progress/kendo-data-query';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { GGItem } from '@app/cp/shared/models/GGItem';
import { CPSearchComponent } from '../../shared/search/cp-search/cp-search.component';
import { OrderItemSecurity } from '../../shared/security/order-item-security';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { OrderBus } from '@app/cp/shared/models/OrderBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { TooltipDirective } from "@progress/kendo-angular-tooltip";
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { concatMap, forkJoin, lastValueFrom, Observable, of, Subscription } from 'rxjs';
import { Message } from '@app/cp/shared/models/message';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DQOIOrderDisplaySettings } from '../../shared/models/DQOIDisplaySettings';
import { IFeatureFlagSet, UseFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { InventoryLocationXrefBus } from '../../shared/models/InventoryLocationXrefBus';
import { VendorService } from '../../shared/services/vendor.service';
@UseFeatureFlagSet()
@Component({
    selector: 'order-lineitems',
    templateUrl: './order-lineitems.component.html',
    styleUrls: ['./order-lineitems.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderLineItemsComponent extends BaseGridEditLineComponent<OrderDetailsBus, null, OrderService> implements OnInit, OnDestroy {
    inventoryLocationFC: MSFilterClass = new MSFilterClass("warehouseId");
    partTypeFC: MSFilterClass = new MSFilterClass("supplierPartTypeMarkUpId");
    accountClassCF: MSFilterClass = new MSFilterClass("accountClassId");
    @ViewChild('cpDispatchSearchOrder') protected CpDispatchSearchOrder: CPSearchComponent;
    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
    @Input() canEditWrongParts: boolean = false;
    @Input() isSubPO: boolean = false;
    @Input() orderStatusId: string = "";
    @Input() requireDispatchJobOnLine: boolean = true;
    @Input() parentObj: OrderBus;
    @Input() markUp: number;
    @Input() margin: number;
    @Input() dqoiOrderDisplaySettings: DQOIOrderDisplaySettings = new DQOIOrderDisplaySettings();
    @Output() setDispatch: EventEmitter<any> = new EventEmitter<any>();
    changingInventory: boolean = false;
    costVerifyThreshold: number;
    invalidRow: number = null;
    isZuggit: boolean = false;
    showHighPriceDialog: boolean = false;
    priceReason: string = "";
    orderPriceOverideReasons_OtherValue  = CommonValues.OrderPriceOverideReasons_Other;
    private subs_featureFlagSet: Subscription;
    _vendorService: VendorService;
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    supplierPartTypeMarkUp: any[] = [];
    supplierId_Zuggit:string = CommonValues.Supplier_Zuggit;
    //featureFlagSet = {};
    override ngOnInit() {
        super.ngOnInit();
        this.superUseCPRefData = this.dqoiOrderDisplaySettings?.useCPRefData;
        //this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
        //    this.featureFlagSet = data;
        //});
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_featureFlagSet);
    }
    
    customCanSaveForm(): boolean {

        let canSave: boolean = !this.requireDispatchJobOnLine;
        if (this.requireDispatchJobOnLine && this.hasEditForm) {
            canSave = CommonFunctions.hasGuidValue(this.editForm.value.dispatchId);
        }
        if (this.editForm.value.isPart && !CommonFunctions.hasGuidValue(this.editForm.value.warehouseId)) {
            canSave = false;
        }
        if (!this.globals.user.isZuggitUser && this.editForm.get("maxCost").value && this.editForm.get("maxCost").value > 0 && this.editForm.get("price").value > this.editForm.get("maxCost").value) { canSave = false; }
        if (this.globals.user.isZuggitUser && this.editForm.get("zuggitMaxCost").value && this.editForm.get("zuggitMaxCost").value > 0 && this.editForm.get("price").value > this.editForm.get("zuggitMaxCost").value) { canSave = false; }
        else if (this.compFeatureFlagSet.featureFlagSet['ui-automated-cost-validation-for-po-part-lines'] && (this.showHighPriceDialog || (this.editForm.get("costVerifyThreshold").value && this.editForm.get("costVerifyThreshold").value > 0 && this.editForm.get("price").value > this.editForm.get("costVerifyThreshold").value && this.editForm.get("price").value != this.selectedData.price && !this.editForm.get("orderPriceOverideReasonId").value))) {
            canSave = false;
        }

        return canSave;
    }
    customCannotSaveMessage(): string {
        let msg: string = "";
        if (this.requireDispatchJobOnLine && this.hasEditForm && !CommonFunctions.hasGuidValue(this.editForm.value.dispatchId)) {
            msg = "Dispatch is Required on Line. ";
        }
        
        this.gridData.forEach(line => {
            if(!this.globals.user.isZuggitUser && line.maxCost && line.maxCost > 0 && line.price > line.maxCost) {
                msg += "Line for " + line.inventoryNumber + " has a price over its max cost of " + line.maxCost + ". ";
            }
            else if(this.globals.user.isZuggitUser && line.zuggitMaxCost && line.zuggitMaxCost > 0 && line.price > line.zuggitMaxCost) {
                msg += "Line for " + line.inventoryNumber + " has a price over its max cost of " + line.zuggitMaxCost + ". ";
            }
        });

        return "Cannot Save " + this.appName + (msg && msg.length > 0 ? ": " + msg : ".");
    }

    public orderItemSecurity: OrderItemSecurity = new OrderItemSecurity("");
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, svc_inv: InventoryService, featureFlagService: FeatureFlagService, vendorService: VendorService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this._vendorService = vendorService;
        this.className = "OrderDetailsBus";
        this.appCode = "OrderDetailLines";
        this.appName = "Order Detail Lines";
        this.aggregates = [{ field: 'amount', aggregate: 'sum' }];
        this.isZuggit = this.globals.user.isZuggitUser    }

    notFullyReceived() {
        return this.gridData && this.gridData.some(x => x.isPart && x.totalReceived < x.quantity);
    }
    override createForm() {
        this.columnFocusAdder = 1;
        this.editForm = new UntypedFormGroup({
            'orderDetailId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'inventoryNumber': new UntypedFormControl(), //Part #
            'manufacturerNumber': new UntypedFormControl(), //Mfg #
            'vendorNbr': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(), //Description
            'ratio': new UntypedFormControl(), //Ratio
            'ratioCp': new UntypedFormControl(), //Ratio
            'quantityReceived': new UntypedFormControl(), //Rcvd
            'quantity': new UntypedFormControl(), //Qty
            'allQuantity': new UntypedFormControl(), //Qty
            'locationQuantity': new UntypedFormControl(), //Qty
            'usedPartQuantity': new UntypedFormControl(), //Used Qty
            'quantityBilled': new UntypedFormControl(), //Qty Billed
            'price': new UntypedFormControl(), //Price
            'maxCost': new UntypedFormControl(), //Price
            'zuggitMaxCost': new UntypedFormControl(), //Price
            'amount': new UntypedFormControl(), //Amount
            'deliveryWarehouseId': new UntypedFormControl(), //Intended Warehouse
            'warehouseId': new UntypedFormControl(), //Intended Warehouse
            'dispatchNumber': new UntypedFormControl(), //Dispatch
            'accountClassId': new UntypedFormControl(), //Class
            'viewedInMobile': new UntypedFormControl(),
            'acknowledged': new UntypedFormControl(), //Acknowledged - remove this is viewedInMobile
            'isWrongPart': new UntypedFormControl(), //Wrong Part
            'replace': new UntypedFormControl(), //Replace
            'toBeReturned': new UntypedFormControl(), //To Be Returned
            'isPart': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'warehouseName': new UntypedFormControl(),
            'removeDispatchPartsRequestId': new UntypedFormControl(),
            'isConstruction': new UntypedFormControl(),
            'markUp': new UntypedFormControl(),
            'margin': new UntypedFormControl(),
            'contractPrice': new UntypedFormControl(),
            'ratioXQty': new UntypedFormControl(),
            'ratioXQtyCp': new UntypedFormControl(),
            'invoiceMarkUpPercent': new UntypedFormControl(),
            'cpWarehouseName': new UntypedFormControl(),
            'costVerifyThreshold': new UntypedFormControl(),
            'orderPriceOverideReasonId': new UntypedFormControl(),
            'orderPriceOverideOtherReason': new UntypedFormControl(),
            'supplierPrice': new UntypedFormControl(),
            'supplierAmount': new UntypedFormControl(),
            'supplierPartTypeMarkUpId': new UntypedFormControl(),
            'supplierPartTypeMarkUpString': new UntypedFormControl(),
        });
    }
    override setForm() {
        this.editForm.patchValue({
            orderDetailId: this.selectedData.orderDetailId,
            orderId: this.selectedData.orderId,
            inventoryId: this.selectedData.inventoryId,
            dispatchId: this.selectedData.dispatchId,
            inventoryNumber: this.selectedData.inventoryNumber,
            manufacturerNumber: this.selectedData.manufacturerNumber,
            vendorNbr: this.selectedData.vendorNbr,
            inventoryDesc: this.selectedData.inventoryDesc,
            ratio: this.selectedData.ratio,
            ratioCp: this.selectedData.ratioCp,
            quantityReceived: this.selectedData.quantityReceived,
            quantity: this.selectedData.quantity,
            allQuantity: this.selectedData.allQuantity,
            locationQuantity: this.selectedData.locationQuantity,
            usedPartQuantity: this.selectedData.usedPartQuantity,
            quantityBilled: this.selectedData.quantityBilled,
            price: this.selectedData.price,
            maxCost: this.selectedData.maxCost,
            zuggitMaxCost: this.selectedData.zuggitMaxCost,
            amount: this.selectedData.amount,
            warehouseId: this.selectedData.warehouseId,
            deliveryWarehouseId: this.selectedData.deliveryWarehouseId,
            dispatchNumber: this.selectedData.dispatchNumber,
            accountClassId: this.selectedData.accountClassId,
            viewedInMobile: this.selectedData.viewedInMobile,
            acknowledged: this.selectedData.acknowledged,
            isWrongPart: this.selectedData.isWrongPart,
            replace: this.selectedData.replace,
            toBeReturned: this.selectedData.toBeReturned,
            isPart: this.selectedData.isPart,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            removeDispatchPartsRequestId: this.selectedData.removeDispatchPartsRequestId,
            warehouseName: this.selectedData.warehouseName,
            isConstruction: this.selectedData.isConstruction,
            markUp: this.selectedData.markUp,
            margin: this.selectedData.margin,
            contractPrice: this.selectedData.contractPrice,
            ratioXQty: this.selectedData.ratioXQty,
            ratioXQtyCp: this.selectedData.ratioXQtyCp,
            invoiceMarkUpPercent: this.selectedData.invoiceMarkUp * 100,
            cpWarehouseName: this.selectedData.cpWarehouseName,
            costVerifyThreshold: this.selectedData.costVerifyThreshold,
            orderPriceOverideReasonId: this.selectedData.orderPriceOverideReasonId,
            orderPriceOverideOtherReason: this.selectedData.orderPriceOverideOtherReason,
            supplierPrice: this.selectedData.supplierPrice,
            supplierAmount: this.selectedData.supplierAmount,
            supplierPartTypeMarkUpId: this.selectedData.supplierPartTypeMarkUpId,
            supplierPartTypeMarkUpString: this.selectedData.supplierPartTypeMarkUpString,
        });
        this.setValidators();

        this.orderItemSecurity = new OrderItemSecurity(this.orderStatusId, this.rights);
    }
    maxPrice = null;
    private setValidators() {
        this.maxPrice = null;
        if (!this.rights.OverrideContractPrice && this.compFeatureFlagSet.featureFlagSet['parts-set-contract-price-per-vendor']) { this.maxPrice = this.selectedData.contractPrice; }
        if (this.isSubPO == true) {
            this.editForm.get('accountClassId').addValidators(Validators.required);
        } else if (this.isSubPO == false) {
            this.editForm.get('warehouseId').addValidators(Validators.required);
            this.editForm.get('accountClassId').addValidators(Validators.required);
        }
        if (this.globals.user.isZuggitUser) {
            this.editForm.get('deliveryWarehouseId').addValidators(Validators.required);
        }
    }

    invSupplierhanged(supplierId: any) {
        if (!supplierId) {
            return;
        }
        var busObj =
        {
            supplierId: supplierId,
            inventoryIds: this.gridData.map(({ inventoryId }) => inventoryId)
        };
        if (supplierId) {
            this._vendorService.getSupplierPartTypeMarkUps(supplierId).subscribe((data: any) => {
                this.supplierPartTypeMarkUp = data;
            });
        }
        if (this.compFeatureFlagSet.featureFlagSet['parts-set-contract-price-per-vendor']) {
            this.svc_inv.getContractPrices(busObj).subscribe((data: any) => {
                console.table(data.primaryReturn);
                var newContractPrices = data.primaryReturn;
                var i = 0;
                for (i = 0; i < this.gridData.length; i++) {
                    var inventoryId = this.gridData[i].inventoryId;
                    var newContractPrice = newContractPrices.find((element) => element.inventoryId = inventoryId);
                    this.gridData[i].contractPrice = null;
                    if (newContractPrice) {
                        this.gridData[i].contractPrice = newContractPrice.contractPrice;
                    }
                }
            });
        }
    }

    invLocCBOChanged(e: any) {
        this.editForm.patchValue({
            warehouseId: e.value,
            warehouseName: e.description,

        });
        if (this.compFeatureFlagSet.featureFlagSet['add-parts-on-hand-qty-in-quotes-and-orders']) {
            this.svc_inv.getLocationQuantityAndAll(this.selectedData.inventoryId, this.locationDetail.locationId).subscribe((data: any) => {
                this.setQuantityInStockDetail(data);

            });
        }
    }
    cpInvLocCBOChanged(e: any) {
        this.editForm.patchValue({
            deliveryWarehouseId: e.value,
            cpWarehouseName: e.description,

        });
    }
    supplierPartTypeMarkUpCBOChanged(e: any, dataItem: OrderDetailsBus) { 
        var val = this.editForm.get("supplierPrice").value;
        var supplierPartTypeMarkUpId = e.supplierPartTypeMarkUpId;
        var mFactor = 1;
        const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === supplierPartTypeMarkUpId);
        if (supplierPartTypeMarkUp) {
            mFactor = mFactor + (supplierPartTypeMarkUp.markUp / 100)
        }
        var tPrice = val * mFactor;
        var quantity = this.editForm.get("quantity").value
        var supplierAmount = val * quantity;
        this.editForm.patchValue({
            price: tPrice,
            supplierAmount: supplierAmount,
            amount: tPrice * quantity,
            supplierPartTypeMarkUpString:e.partType
        });
        dataItem.amount = tPrice * quantity;
    }
    setQuantityInStockDetail(item: any) {

        this.editForm.patchValue({
            locationQuantity: item.localQuantity,
            allQuantity: item.allQuantity,
        });

    }
    get inventoryNumberCaption(): string {
        return this.isSubPO ? "Item #" : "Part #";
    }
    get dispatchNumberCaption(): string {
        if (this.globals.user.isZuggitUser) return "Sales"
        return this.isSubPO || this.isConstruction ? "Job" : "Dispatch";
    }
    inventoryDescReadOnly(dataItem: OrderDetailsBus): boolean {
        return dataItem.isPart;
    }
    get canEditWrongPart(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData) {
            if (this.canEditWrongParts) {
                can = true;
            }
        }

        return can;
    }

    get lineReceived(): boolean {
        let recd: boolean = false;
        var a = this.compFeatureFlagSet.featureFlagSet["restrict-order-line-editing-for-received-lines"];

        if (this.canEdit && this.selectedData && this.compFeatureFlagSet.featureFlagSet["restrict-order-line-editing-for-received-lines"]) {
            recd = (this.selectedData && this.selectedData.totalReceived && this.selectedData.totalReceived != 0);
        }

        return recd;
    }

    defDispatchId: any;
    defDispatchNumber: string;
    defDispatchAccountClassId: any;
    defInventoryLocId: any = CommonValues.InventoryLocation_StagingWarehouse;
    defAccountClassId: any;
    lassId: any;
    public statusChange(id: string) { this.orderItemSecurity = new OrderItemSecurity(id, this.rights); }
    public setSupplier(id: string) {
        if (id) {
            this._vendorService.getSupplierPartTypeMarkUps(id).subscribe((data: any) => {

                this.supplierPartTypeMarkUp = data;

            });
        }
    }
    override setFromReferenceData(data: OrderDetailsBus) {
        data.warehouseName = this.warehouseName(data.warehouseId);
        data.cpWarehouseName = this.cPWarehouseName(data.deliveryWarehouseId);
        return data;
    }

    getChangedObject(data: OrderDetailsBus) {
        let busObj: OrderDetailsBus = new OrderDetailsBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    // busObj.markup = this.editForm.value.markup / 100;
    protected override save(data: OrderDetailsBus) {

        let busObj: OrderDetailsBus = this.getChangedObject(data);
        //   busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //   busObj.setParentId(this._parentId);

        this.svc_data.saveOrderDetail(busObj).subscribe((info: OrderMessageInfo) => {

            if (!info.saveError) {
                let dataObj: OrderDetailsBus = new OrderDetailsBus(info.orderDetailsBus);
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(info.orderDetailsBus, info.message);
            }
        });
    }
    costChange(event, dataItem, editForm) {

    }
    muChange(event, dataItem: OrderDetailsBus, editForm) {
        let mu = (event * 1) / 100;
        //dataItem.price = dataItem.cost * (1 + mu);
        //this.editForm.patchValue({
        //    price: dataItem.cost * (1 + mu),
        //    amount: dataItem.cost * (1 + mu) * (dataItem.quantity)
        //});

    }
    @Input() detail: any;
    protected getEditedGrid(): any[] {
        let gridData = _.cloneDeep(this.gridData);
        if (this.isEditing) {
            if (this.isNew) {
                gridData.push(this.editForm.value);
            } else {
                gridData[this.editedRowIndex] = this.editForm.value;
            }
        }

        return gridData;
    }

    sumGrid(dataItem: OrderDetailsBus = null) {

        let gridData = this.getEditedGrid(); // _.cloneDeep(this.gridData);
        //if (dataItem != null) {
        //    gridData.push(dataItem);
        //}
        this.aggregateResults = aggregateBy(gridData, this.aggregates);
        //        const result = aggregateBy(gridData, [{ aggregate: "sum", field: "amount" }]);
        if (this.hasDetail) {
            this.detail.total = this.aggregateResults.amount.sum;
        }
    }
    get hasDetail(): boolean {
        return CommonFunctions.hasValue(this.detail);
    }
    tempDataItem: OrderDetailsBus = null;
    onBlur(event, dataItem: OrderDetailsBus, editForm: UntypedFormGroup, field: string) {
        let isAdded = !CommonFunctions.hasValue(dataItem.hasId);
        var vals = editForm.value;

        var mFactor = 1;
        if (field == "supplierPrice") { 
            var supplierPartTypeMarkUpId = editForm.get("supplierPartTypeMarkUpId").value;
            const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === supplierPartTypeMarkUpId);
            if (supplierPartTypeMarkUp) {
                mFactor = mFactor + (supplierPartTypeMarkUp.markUp / 100)
            }
        }
        if (field == "supplierPriceR") {
            dataItem.amount = 0;
        }
        if (field == "price" && this.orderItemSecurity.newItemPriceChangeOnly && !dataItem.isAdded && editForm.get(field).value !== dataItem[field]) {
            editForm.patchValue({ price: dataItem["price"] });
            this.globals.notifyError("You cannot change the price of an existing item for orders in this status.", true);
        }
        else if (!this.globals.user.isZuggitUser && field == "price" && editForm.get("maxCost").value && editForm.get("maxCost").value > 0 && editForm.get("price").value > editForm.get("maxCost").value) {
            this.globals.notifyError("Price is over the the max price " + editForm.get("maxCost").value + ".", true);
        }
        else if (this.globals.user.isZuggitUser && field == "price" && editForm.get("zuggitMaxCost").value && editForm.get("zuggitMaxCost").value > 0 && editForm.get("price").value > editForm.get("zuggitMaxCost").value) {
            this.globals.notifyError("Price is over the the max price " + editForm.get("zuggitMaxCost").value + ".", true);
        }

        else if (this.compFeatureFlagSet.featureFlagSet['ui-automated-cost-validation-for-po-part-lines'] && field == "price" && editForm.get("costVerifyThreshold").value && editForm.get("costVerifyThreshold").value > 0 && editForm.get("price").value > editForm.get("costVerifyThreshold").value && editForm.get("price").value != this.selectedData.price) {

            this.orderPriceOverideOtherReason = editForm.get("orderPriceOverideOtherReason").value;
            this.orderPriceOverideReasonId = editForm.get("orderPriceOverideReasonId").value;
            this.tempDataItem = dataItem;
            this.costVerifyThreshold = editForm.get("costVerifyThreshold").value;
            this.showHighPriceDialog = true;
        }
        else if (this.compFeatureFlagSet.featureFlagSet['ui-automated-cost-validation-for-po-part-lines'] && field == "supplierPrice" && editForm.get("costVerifyThreshold").value && editForm.get("costVerifyThreshold").value > 0 && editForm.get("supplierPrice").value * mFactor  > editForm.get("costVerifyThreshold").value && editForm.get("supplierPrice").value != this.selectedData.supplierPrice) {

            this.orderPriceOverideOtherReason = editForm.get("orderPriceOverideOtherReason").value;
            this.orderPriceOverideReasonId = editForm.get("orderPriceOverideReasonId").value;
            this.tempDataItem = dataItem;
            this.costVerifyThreshold = editForm.get("costVerifyThreshold").value;
            dataItem.amount = 0;
            this.showHighPriceDialog = true;
        }
        else if ((field == "supplierPrice" || field == "supplierPriceR") && editForm.get("supplierPrice").value > 0 && this.selectedData.supplierPrice != editForm.get("supplierPrice").value) {
            var val = editForm.get("supplierPrice").value;
            var supplierPartTypeMarkUpId = editForm.get("supplierPartTypeMarkUpId").value;
            var mFactor = 1;
            const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === supplierPartTypeMarkUpId);
            if (supplierPartTypeMarkUp) {
                mFactor = mFactor + (supplierPartTypeMarkUp.markUp / 100)
            }
            var tPrice = val * mFactor;
            var quantity = editForm.get("quantity").value
            var supplierAmount = val * quantity;
            editForm.patchValue({
                price: tPrice,
                supplierAmount: supplierAmount,
                amount: tPrice * quantity
            });
            dataItem.amount = tPrice * quantity;
        }
        else {

            var markUpRatio = 1;
            var markUp = this.markUp;
            if (this.selectedData.inventoryId == CommonValues.BillingCode_CTAX || this.selectedData.inventoryId == CommonValues.BillingCode_CFREIGHT || this.selectedData.inventoryId == CommonValues.BillingCode_PRMAT) {
                markUp = null;
            }
            /*if (this.selectedData.inventoryId == CommonValues.BillingCode_PRMAT) { // excluding BillingCode_CTAX and BillingCode_CFREIGHT as per the request on 7/3/2023
                markUp = null;
            }*/
            if (markUp) {
                markUpRatio = markUpRatio + (markUp / 100);
            }
            var marginRatio = 1;
            var margin = this.margin;
            if (this.selectedData.inventoryId == CommonValues.BillingCode_CTAX || this.selectedData.inventoryId == CommonValues.BillingCode_CFREIGHT || this.selectedData.inventoryId == CommonValues.BillingCode_PRMAT) {
                margin = null;
            }
            /*if (this.selectedData.inventoryId == CommonValues.BillingCode_PRMAT) { // excluding BillingCode_CTAX and BillingCode_CFREIGHT as per the request on 7/3/2023
                markUp = null;
            }*/
            if (margin) {
                marginRatio = (1 / (1 - (margin / 100)));
            }

            if (field == 'quantity') {

                var val = editForm.get(field).value;
                var ratio = editForm.get("ratio").value;
                var ratioCp = editForm.get("ratioCp").value;
                if (!ratio) ratio = 1;
                if (!val) val = 1;
                var ratioXQty = val * ratio;
                var ratioXQtyCp = val * ratioCp;
                dataItem.ratioXQty = ratioXQty;
                dataItem.ratioXQtyCp = ratioXQtyCp;
                editForm.patchValue({
                    ratioXQty: ratioXQty,
                    ratioXQtyCp: ratioXQtyCp,
                });
            }

            if (field == "priceR" || editForm.get(field).value !== dataItem[field] || (vals.quantity * marginRatio * markUpRatio * vals.price) !== vals.amount || isAdded) {
                if (field == "priceR") {
                    var val = editForm.get("price").value;
                    //                var vals = editForm.value;
                    dataItem["price"] = val;
                }
                else {
                    var val = editForm.get(field).value;
                    //                var vals = editForm.value;
                    dataItem[field] = val;
                    }
                // var val = editForm.get(field).value;
                // //                var vals = editForm.value;
                // dataItem[field] = val;
                if (field == 'quantity' || field == "price" || field == "priceR") {

                    let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * marginRatio * markUpRatio * vals.price), 2);
                    var supplierPrice = editForm.get("supplierPrice").value;
                    let supplierAmount: number = CommonFunctions.RoundToPrecision((vals.quantity * marginRatio * markUpRatio * supplierPrice), 2);
                    editForm.patchValue({
                        amount: amt,
                        supplierAmount: supplierAmount ? supplierAmount: null,
                        markUp: markUp, 
                        margin: margin
                    });
                    dataItem.markUp = markUp;
                    dataItem.margin = margin;
                    this.selectedData.markUp = markUp;
                    this.selectedData.margin = margin;
                    dataItem.amount = amt;
                    editForm.get("amount").markAsDirty();
                }

                let paramDataItem: OrderDetailsBus = isAdded ? dataItem : null;
                this.sumGrid(paramDataItem); //dataItem.hasId ? null : dataItem);
                //     this.sumAmt();
            }
        }
    }
    override deleteIndividual(data: OrderDetailsBus) {
        if (data.hasId) {
            this.svc_data.deleteOrderDetail(data.orderDetailId).subscribe((info: OrderMessageInfo) => {
                if (info.saveError) {
                    this.globals.notifyError(CommonValues.Message_ErrorDeleting + " - " + info.message, true);
                }
                else {
                    this.removeLocal(data);
                    this.globals.notifySuccess(CommonValues.Message_SuccessfullyDeleted);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    public accountClass(id: string) {
        return this.referenceData.accountClasses.find(x => x.value === id);
    }
    partSuppliers: InventorySuppliersBus[];
    partSuppliersActive: boolean = false;
    partSuppliersHeight: number = 0;
    showInventorySuppliers(dataItem: OrderDetailsBus) {
        this.svc_inv.getInventorySuppliers(dataItem.inventoryId).subscribe((data: InventorySuppliersBus[]) => {
            if (CommonFunctions.hasArrayValue(data)) {
                if (data.length > 20) {
                    this.partSuppliersHeight = 600;
                }
                else {
                    this.partSuppliersHeight = 0;
                }
            }
            this.partSuppliers = data;
            this.partSuppliersActive = true;
        });
    }
    closePartSupplier() {
        this.partSuppliersActive = false;
    }
    override afterDelete() {
        //   this.reOrder();
        this.sumGrid();
    }
    protected setCommonValues() {
        if (CommonFunctions.hasGuidValue(this.common.getParam("DispatchId"))) {
            this.defDispatchId = this.common.getParam("DispatchId");
            this.defDispatchNumber = this.common.getParam("DispatchNumber");
            this.defDispatchAccountClassId = this.common.getParam("DispatchAccountClassId");

        }
        else {
            if (this.globals.user.isZuggitUser)
            {
                this.defDispatchAccountClassId = CommonValues.AccountClass_Zuggit;
                if (!this.defDispatchId && this.gridData) {
                    var rowIndex = this.gridData.findIndex(e => e.dispatchId);
                    if (rowIndex >= 0) {
                        this.defDispatchId = this.gridData[rowIndex].dispatchId
                        this.defDispatchNumber = this.gridData[rowIndex].dispatchNumber;
                    }
                }
            }
        }
    }
    resetDefaultValues() {
        //this.setCommonValues();
        this.defDispatchId = null;
        this.defDispatchNumber = null;
        this.defDispatchAccountClassId = null;
        this.defInventoryLocId = CommonValues.InventoryLocation_StagingWarehouse;
        this.defAccountClassId = null;
    }
    override clear() {
        super.clear();
        this.resetDefaultValues();

    }
    protected override customAddNew(): boolean {
        if (!CommonFunctions.hasGuidValue(this.defDispatchId)) {

            this.setCommonValues();
        }
        //        if (CommonFunctions.hasGuidValue(this.defDispatchId) && this.requireDispatchJobOnLine) {
        if (CommonFunctions.hasGuidValue(this.defDispatchId)) {
            this.selectedData.dispatchId = this.defDispatchId;
            this.selectedData.dispatchNumber = this.defDispatchNumber;
            this.selectedData.accountClassId = this.defDispatchAccountClassId;

        }
        else {
            //set default accountclass if CP order
            if (this.compFeatureFlagSet.featureFlagSet["order-climatepros-def-acctclass-newlines"]) {
                if (this.parentObj?.customerId == CommonValues.CustomerId_ClimatePros) {
                    this.selectedData.accountClassId = this.defAccountClassId; // this.defDispatchAccountClassId;
                }
            }
        }
        if (CommonFunctions.hasGuidValue(this.defInventoryLocId)) {
            {
                if (this.parentObj.customerId != CommonValues.CustomerId_ClimatePros || this.defInventoryLocId != CommonValues.InventoryLocation_StagingWarehouse) { this.selectedData.warehouseId = this.defInventoryLocId; }
            }
        }
        //if (CommonFunctions.hasGuidValue(this.common.getParam("DispatchId"))) {
        //    this.selectedData.dispatchId = this.common.getParam("DispatchId");
        //    this.selectedData.dispatchNumber = this.common.getParam("DispatchNumber");
        //    this.selectedData.accountClassId = this.common.getParam("DispatchAccountClassId");
        //}
        return false;
    }
    public showOnlyParts(dataItem:any ): boolean {
        return dataItem.isPart && dataItem.quantity==1;
    }
    protected setDefaultsFromLocal: boolean = false;
    protected override customSaveLocal(data: OrderDetailsBus) {
        if (CommonFunctions.hasGuidValue(data.dispatchId)) {
            if (data.dispatchId != this.defDispatchId) {
                this.defDispatchId = data.dispatchId;
                this.defDispatchNumber = data.dispatchNumber;
            }
            if (data.accountClassId !== this.defDispatchAccountClassId) {
                this.defDispatchAccountClassId = data.accountClassId;
            }
            this.setDefaultsFromLocal = true;
        }
        else {
            if (!CommonFunctions.hasGuidValue(this.defAccountClassId) && CommonFunctions.hasGuidValue(data.accountClassId)) {
                this.defAccountClassId = data.accountClassId;
            }
        }
        if (CommonFunctions.hasGuidValue(data.warehouseId)) {
            this.defInventoryLocId = data.warehouseId;
        }
    }
    override processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {

            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
            this.sendParentMessageByMessage(new Message({
                messageType: MessageType.aggregateResultsUpdated,
                value: this.aggregateResults,
            }));
            if (!this.setDefaultsFromLocal) {
                let first: OrderDetailsBus = this.gridData[0];
                this.defDispatchId = first.dispatchId;
                this.defDispatchNumber = first.dispatchNumber;
                this.defDispatchAccountClassId = first.accountClassId;
                this.defInventoryLocId = first.warehouseId;
                this.defAccountClassId = first.accountClassId;
                this.setDefaultsFromLocal = true;
            }
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].warehouseName) {
                    this.gridData[i].warehouseName = this.warehouseName(this.gridData[i].warehouseId);
                }
                if (!this.gridData[i].cpWarehouseName) {
                    this.gridData[i].cpWarehouseName = this.cPWarehouseName(this.gridData[i].deliveryWarehouseId);
                }
            }
        }
    }
    clearAggrigates() {

        this.aggregateResults = null;
    }
    public getTotalAmount(): number {
        if (!this.dataLoading) {
            this.processGridData();
            if (this.aggregateResults) {
                return this.aggregateResults.amount.sum;
            } else {
                return 0;
            }
        } else {
            return 0;
        }
    }
    get accountClasses(): GGItem[] {
        let classes: GGItem[] = [];
        if (this.hasReferenceData) {

            //only show Refer Service or Refer Construction when the order is for Climate Pros and isnt tied to a dispatch
            if (this.compFeatureFlagSet.featureFlagSet["climate-pros-orders-not-tied-to-dispatch"] &&
                this.parentObj?.customerId == CommonValues.CustomerId_ClimatePros &&
                !CommonFunctions.hasGuidValue(this.common.getParam('DispatchId'))) {
                classes = this.referenceData.accountClassesService.concat(this.referenceData.accountClassesConstruction);
                classes = classes.filter(x => x.value == "06ecdbc2-154f-4e4b-b482-d996f4fd08b6" || x.value == "83a686a4-a708-4d80-8be2-294eda88be36");
            }
            else {
                classes = this.isConstruction ? this.referenceData.accountClassesConstruction : this.referenceData.accountClassesService;
            }
        }
        return classes;
    }
    override customDispatchSelectedSetForm(value: any) {
        if (value != null) {
            this.editForm.patchValue({
                accountClassId: value.AccountClassId
            });

            if (this.compFeatureFlagSet.featureFlagSet["climate-pros-orders-not-tied-to-dispatch"]) {
                this.setDispatch.emit(value);
            }
        }

    }
    dispatchSearchOrder: boolean = false;
    override doDispatchSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.dispatchSelected({ dispatchNumber: "", dispatchId: null });
        }
        else {
            this.ctrlOpenFlag = true;
            this.dispatchSearchOrder = true;
            setTimeout(() => {
                this.CpDispatchSearchOrder.setSearchText(e);
            }, 500);
        }
    }
    override dispatchSelected(value: any) {
        this.dispatchSearchOrder = false;
        if (value != null) {

            this.editForm.patchValue({
                dispatchNumber: value.DispatchNumber,
                dispatchId: value.DispatchId
            });
            this.customDispatchSelectedSetForm(value);
            this.setDirty();
        }
        this.closeCtrlOpenFlag = true;
    }

    override dispatchValidationError(event: any) {
        this.ctrlOpenFlag = true;
        this.dispatchSearchOrder = true;
    }
    override doDispatchValidate(value: any) {

        var skipCheck = false;
        if (!value) {

            this.editForm.patchValue({
                dispatchNumber: value,
                dispatchId: null
            });
            skipCheck = true;
        }
        else {
            var dispatchId = this.editForm.controls["dispatchId"].value;
            var dispatchNumber = this.editForm.controls["dispatchNumber"].value;
            if (dispatchId) {
                if (dispatchNumber === value) { skipCheck = true; }
            }
        }

        if (!skipCheck) {
            this.dispatchSearchOrder = false;

            this.CpDispatchSearchOrder.validate(value);
        }

    }

    override customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "viewedInMobile") {
            this.editForm.patchValue({
                viewedInMobile: e.target.checked
            });

        }
        if (column.field === "isWrongPart") {
            this.editForm.patchValue({
                isWrongPart: e.target.checked
            });

        }
        if (column.field === "replace") {
            this.editForm.patchValue({
                replace: e.target.checked
            });

        }
        if (column.field === "toBeReturned") {
            this.editForm.patchValue({
                toBeReturned: e.target.checked
            });

        }
        if (column.field === "isPrintable") {
            this.editForm.patchValue({
                isPrintable: e.target.checked
            });

        }
    }
    override setInventorySearchData(value: any) {

        if (this.orderItemSecurity.taxAndFreightOnly && (value.InventoryId != CommonValues.BillingCode_CTAX && value.InventoryId != CommonValues.BillingCode_CFREIGHT && value.InventoryId != CommonValues.BillingCode_PRMAT)) {
            this.cancelHandler();
            this.globals.notifyError("Only PRMAT, CFREIGHT or CTAX can be added to orders in this status.", true);
        }
        if (this.orderItemSecurity.changePartialReceiveItems && this.selectedData.totalReceived > 0) {
            this.cancelHandler();
            this.globals.notifyError("You cannot change the part number of a partially received item.", true);
        }
        else {
            let param: CommonParam = new CommonParam();
            param.customerId = this.parentObj.customerId;
            param.locationId = this.parentObj.locationId;
            param.addParam("InventoryId", value.InventoryId);
            param.addParam("IsPart", true);
            param.addParam("SupplierId", this.parentObj.supplierId);
            param.addParam("CompanyId", this.globals.companyId);
            param.addParam("GetAllFields", false);
            this.setInventoryLine(param);
        }
    }
    public sameDispatchId() {
        var rVal = true;
        if (this.gridData && this.gridData.length) {

            for (let i = 0; i < this.gridData.length - 1; i++) {
                //if (this.gridData[i].isPart) {
                if (this.gridData[i].dispatchId != this.gridData[i + 1].dispatchId) {
                    rVal = false;
                    this.invalidRow = i + 2;
                    return rVal;
                }
            }

        }
        this.invalidRow = null;
        return rVal;

    }

    setInventoryLine(param: CommonParam) {
        this.dataLoading = true;
        this.inventorySearching = true;

        this.svc_data.setOrderLineFromInventoryId(param).subscribe(
            {
                next: (info: BaseMessageInfo) => {
                    this.selectedData.changeInventoryItem(info.primaryReturn, !this.changingInventory, this.parentObj.customerId);
                    this.changingInventory = false;
                    let busObj: v_InventoryBus = info.primaryReturn as v_InventoryBus;
                    if (!this.isSubPO) {
                        this.selectedData.price = busObj.currentCost;
                        this.selectedData.vendorNbr = busObj.vendorNbr;
                        let isPartOrNonInvBC: boolean = !CommonFunctions.hasGuidValue(busObj.billingTypeId) || busObj.billingTypeId == CommonValues.BillingType_NonInventoryPart;

                        if (!this.selectedData.warehouseId) {
                            if (this.parentObj.customerId != CommonValues.CustomerId_ClimatePros || this.defInventoryLocId != CommonValues.InventoryLocation_StagingWarehouse) {
                                this.selectedData.warehouseId = this.defInventoryLocId;
                            }
                        }
                        if (CommonFunctions.hasGuidValue(this.defInventoryLocId) && isPartOrNonInvBC) {
                            if (this.parentObj.customerId != CommonValues.CustomerId_ClimatePros || this.defInventoryLocId != CommonValues.InventoryLocation_StagingWarehouse) {
                                this.selectedData.warehouseId = this.defInventoryLocId;
                            }
                        }
                        else if (info.dcValues != null && CommonFunctions.hasGuidValue(info.dcValues.InventoryLocationId) && isPartOrNonInvBC) {
                            this.selectedData.warehouseId = info.dcValues.InventoryLocationId;
                        }
                        //this.selectedData.ContractPrice = busObj.ContractPrice;
                    }
                    else {
                        this.selectedData.price = 1;
                    }
                    if (this.globals.user.isZuggitUser) {
                        this.selectedData.accountClassId = CommonValues.AccountClass_Zuggit;
                        let max = "";
                        this.gridData.forEach(item => {
                            if (item.deliveryWarehouseId > max) {
                                max = item.deliveryWarehouseId;
                            }
                        });
                        this.selectedData.deliveryWarehouseId = max;
                    }
                    if (info.dcValues != null && CommonFunctions.hasNumberValueIncludingZero(info.dcValues.OrderInvoiceMarkup))
                        { this.selectedData.invoiceMarkUp = info.dcValues.OrderInvoiceMarkup }
                    this.selectedData.ratio = busObj.ratio;
                    this.selectedData.ratioXQty = busObj.ratio;
                    this.selectedData.ratioCp = busObj.cpRatio;
                    this.selectedData.ratioXQtyCp = busObj.cpRatio;
                    this.selectedData.manufacturerNumber = busObj.manufacturerNumber;
                    this.selectedData.inventoryDesc = busObj.fullDescription;
                    this.selectedData.maxCost = busObj.maxCost;
                    this.selectedData.costVerifyThreshold = busObj.costVerifyThreshold;
                    this.selectedData.zuggitMaxCost = busObj.zuggitMaxCost

                    switch (busObj.inventorySubCategoryId.toLowerCase()) {
                        case CommonValues.InventorySubClass_Compressors.toLowerCase():
                            this.selectedData.supplierPartTypeMarkUpId = CommonValues.SupplierPartTypeMarkUp_Compressors.toLowerCase();
                            break;
                        case CommonValues.InventorySubClass_Refrigerant.toLowerCase():
                            this.selectedData.supplierPartTypeMarkUpId = CommonValues.SupplierPartTypeMarkUp_Refrigerant.toLowerCase();
                            break;
                        default:
                            this.selectedData.supplierPartTypeMarkUpId = CommonValues.SupplierPartTypeMarkUp_Parts.toLowerCase();
                            break;
                    }
                    if (this.supplierPartTypeMarkUp && this.supplierPartTypeMarkUp.length > 0) {
                        const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === this.selectedData.supplierPartTypeMarkUpId);
                        if (supplierPartTypeMarkUp) {
                            this.selectedData.supplierPartTypeMarkUpString = supplierPartTypeMarkUp.partType;
                            this.editForm.patchValue({
                                supplierPartTypeMarkUpString: this.selectedData.supplierPartTypeMarkUpString,
                                supplierPartTypeMarkUpId: this.selectedData.supplierPartTypeMarkUpId
                            });
                        }
                    }
                    busObj.inventorySubCategoryId 
                    if (this.selectedData.inventoryId != CommonValues.BillingCode_CTAX && this.selectedData.inventoryId != CommonValues.BillingCode_CFREIGHT && this.selectedData.inventoryId != CommonValues.BillingCode_PRMAT) {
                        this.selectedData.markUp = this.markUp;
                        this.selectedData.margin = this.margin;
                    }
                    if (this.globals.user.isZuggitUser) {
                        this.selectedData.warehouseId = CommonValues.InventoryLocation_ZuggitStagingWarehouse;
                    }
                    /* if (this.selectedData.inventoryId != CommonValues.BillingCode_PRMAT) { //excluding BillingCode_CTAX and BillingCode_CFREIGHT as per the request on 7/3/2023
                         this.selectedData.markUp = this.markUp;
                     }*/
                    else {
                        this.selectedData.markUp = null;
                        this.selectedData.margin = null;
                    }
                    this.ensureEditFormInEditMode();
                    this.editForm.patchValue({
                        markUp: this.selectedData.markUp,
                        margin: this.selectedData.margin
                    });

                    let service1: Observable<any> = of(null);
                    let service2: Observable<any> = of(null);

                    if (this.compFeatureFlagSet.featureFlagSet['add-parts-on-hand-qty-in-quotes-and-orders'] && busObj.isPart) {
                        service1 = this.svc_inv.getLocationQuantityAndAll(this.selectedData.inventoryId, this.parentObj.locationId);
                    }

                    if (this.compFeatureFlagSet.featureFlagSet['parts-set-contract-price-per-vendor']) {
                        var busObj2 =
                        {
                            supplierId: this.parentObj.supplierId,
                            inventoryIds: [this.selectedData.inventoryId]
                        };
                        service2 = this.svc_inv.getContractPrices(busObj2);
                    }
                    forkJoin([
                        service1,
                        service2
                    ]).subscribe(
                        {
                            next:
                                ([partsQuantity, contractPrices]) => {
                                    console.log('partsQuantity', partsQuantity);
                                    console.log('contractPrices', contractPrices);
                                    if (partsQuantity) {
                                        this.setQuantityInStockDetail(partsQuantity);
                                        this.selectedData.allQuantity = partsQuantity.allQuantity;
                                        this.selectedData.locationQuantity = partsQuantity.localQuantity;
                                    }
                                    if (contractPrices) {
                                        var newContractPrices = contractPrices.primaryReturn;
                                        var i = 0;
                                        var inventoryId = this.selectedData.inventoryId;
                                        var newContractPrice = newContractPrices.find((element) => element.inventoryId = inventoryId);
                                        this.selectedData.contractPrice = null;
                                        if (newContractPrice) {
                                            this.selectedData.contractPrice = newContractPrice.contractPrice;
                                        }
                                        this.editForm.patchValue({
                                            contractPrice: this.selectedData.contractPrice,
                                        });
                                        this.editForm.controls["price"].clearValidators();
                                        if (this.selectedData.contractPrice) {
                                            this.editForm.controls["price"].setValidators([Validators.max(this.selectedData.contractPrice)]);
                                        }
                                        this.editForm.controls["price"].updateValueAndValidity();
                                    }
                                    this.selectedData.calculateTotals();
                                    this.setForm();
                                    this.sumGrid(this.selectedData);
                                    this.setGridRow(this.selectedData, this.editedRowIndex);
                                    this.setDirty();
                                    this.dataLoading = false;
                                    this.inventorySearching = false;
                                    this.cd.detectChanges();
                                    if (!this.compFeatureFlagSet.featureFlagSet["ui-hide-inventory-still-searching-notification"]) {
                                        this.globals.notifyInfo("Inventory search item selected. You can now click out of the edit row.");
                                    }
                                },
                            error: (err) => {
                                console.error(err);
                                this.dataLoading = false;
                                this.inventorySearching = false;
                                if (this.selectedData.isAdded) {
                                    this.globals.notifyError(`Error getting inventory data. Since this is a newly added row; ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                                } else {
                                    this.globals.notifyError(`Error getting inventory data. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                                }
                            }
                    });
                },
                error: (err) => {
                    console.error(err);
                    this.dataLoading = false;
                    this.inventorySearching = false;
                    if (this.selectedData.isAdded) {
                        this.globals.notifyError(`Error getting inventory data. Since this is a newly added row; ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                    } else {
                        this.globals.notifyError(`Error getting inventory data. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                    }

                }
            });
    }
    setGridRow(dataItem: OrderDetailsBus, rowIndex: number) {
        if (CommonFunctions.hasValue(dataItem) && CommonFunctions.hasArrayElementValue(this.gridData, rowIndex)) {
            try {
                this.gridData[rowIndex] = dataItem;
            }
            catch (err) {

            }
        }
    }
    onChangeSerialNumber(event: any, dataItem: OrderDetailsBus, rowIndex: number) {
        dataItem.serialNumber = event.srcElement.value;
        dataItem.isUpdated = true;
        this.SetChanged();
    }
    public onChange(value: string): void {
        var isUpdated = true;
    } 

    changeInventoryOnLineItem(input: boolean) {
        this.changingInventory = input;
        this.showCpSearchDialog = true;
    }
    public rebindGridData() {
        this.dataBinding.rebind();
    }
    public override cellClickHandler({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked: boolean = false): void {
        this.changingInventory = true;
        super.cellClickHandler({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked);
    }
    public override addHandler(): void {
        this.changingInventory = false;
        super.addHandler();
    }
    rowCallback(context: RowClassArgs) {
        if (context.dataItem)
            return {
                inFinance: context.dataItem.inFinance,
            };
        return {};
    }
    override canDelete(dataItem: OrderDetailsBus): boolean {
        return dataItem.inFinance ? this.rights.FinancialLockOverride : true;
    }
    partLocations: InventoryLocationXrefBus[];
    partLocationsActive: boolean = false;
    partLocationsHeight: number = 0;
    closePartLocations() {
        this.partLocationsActive = false;
    }
    showMainOnly: boolean = true;
    subs_data: Subscription;
    partSummary: String = "";
    showMainOnlyChanged(value) {
        this.showMainOnly = value;
        this.showInventoryLocations(this.selectedRowData);
    }
    orderPriceOverideReasonId = null;
    orderPriceOverideOtherReason =""
    cancelPriceDialog() {
        if (this.rights.ZuggitPricing && this.compFeatureFlagSet.featureFlagSet['ui-zuggit-pricing-for-fuggit-supplier-orders-and-quote'] && this.supplierId_Zuggit == this.parentObj?.supplierId) 
        {
            this.editForm.patchValue({
                supplierPrice: 0,
                supplierAmount: 0,
                price: 0,
                amount: 0,
            });

        }
            else {
            this.editForm.patchValue({
                price: 0,
                amount: 0,
            });
            this.tempDataItem.amount = 0;
            }

        this.showHighPriceDialog = false;
        if (this.rights.ZuggitPricing && this.compFeatureFlagSet.featureFlagSet['ui-zuggit-pricing-for-fuggit-supplier-orders-and-quote'] && this.supplierId_Zuggit == this.parentObj?.supplierId) {

            this.onBlur(null, this.tempDataItem, this.editForm, "supplierPrice");
        }
    }
    closePriceDialog() {
       
        this.editForm.patchValue({
            orderPriceOverideOtherReason: this.orderPriceOverideOtherReason,
            orderPriceOverideReasonId: this.orderPriceOverideReasonId,
        });
        this.showHighPriceDialog = false;
        if (this.rights.ZuggitPricing && this.compFeatureFlagSet.featureFlagSet['ui-zuggit-pricing-for-fuggit-supplier-orders-and-quote'] && this.supplierId_Zuggit == this.parentObj?.supplierId)
        {
                this.onBlur(null, this.tempDataItem, this.editForm, "supplierPriceR");
            }
        else
        {
            this.onBlur(null, this.tempDataItem, this.editForm, "priceR");
        }
       // this.onBlur(null, this.tempDataItem, this.editForm, "priceR");
    }
    showInventoryLocations(dataItem: OrderDetailsBus) { 
        if (this.selectedRowData?.inventoryId != dataItem.inventoryId) {
            this.subs_data = this.svc_inv.getOnly(dataItem.inventoryId).subscribe((dataObj1: any) => {
                next: {
                    if (dataObj1) {
                        try {
                            this.partSummary = dataObj1.inventoryDesc;
                        } catch (error) {
                        }

                    }
                }
                error => {
                    this.globals.notifyError(`Error getting inventory data.`, true);

                }
        });
            this.selectedRowData = _.cloneDeep(dataItem);
        }
        this.svc_inv.getCPInventoryLocationXref(dataItem.inventoryId).subscribe((data: any) => {
            next: {
                if (CommonFunctions.hasArrayValue(data.result)) {
                    if (data.length > 20) {
                        this.partLocationsHeight = 600;
                    }
                    else {
                        this.partLocationsHeight = 0;
                    }
                }

                let arr = [];
                if (CommonFunctions.hasArrayValue(data.result)) {
                    for (let i = 0; i < data.result.length; i++) {
                        let newObj: InventoryLocationXrefBus = new InventoryLocationXrefBus(data.result[i]);
                        newObj.warehouse = this.referenceData.getCpWarehouse(newObj.inventoryLocationId);
                        if (newObj.quantity > 0 && (!((newObj.warehouse ?? "") == "Staging Warehouse")) && ((!this.showMainOnly) || (newObj.warehouse ?? "").toUpperCase().includes("MAIN"))) {
                            arr.push(newObj);
                        }
                    }
                }
                arr.sort((a, b) => (a.quantity < b.quantity) ? 1 : -1);

                this.partLocations = null;
                this.partLocations = _.cloneDeep(arr);
                this.partLocationsActive = true;
            }
            error: (err) => {
                this.globals.notifyError(`Error getting inventory data.`, true);

            }
        });
    }

}
